import { ITEM_KINDS, STATES } from '../../../constants';

export function OffersConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_OFFERS, {
    url: '/move-in-offers',
    views: {
      '@': {
        template: '<upd-offers></upd-offers>',
      },
    },
    scrollTop: true,
    title: 'Move-In Offers',
    titleBar: {
      title: 'Search Move-In Offers',
      save: 'Average Dollars Saved: $108',
      icon: 'deals',
    },
    data: {
      moveItem: {
        type: ITEM_KINDS.OFFER,
        singleton: true,
      },
    },
  });
}
